import React from 'react';
import Head from 'next/head';
import Link from 'next/link';

const TermsPage = () => {
  return (
    <>
      <Head>
        <title>Terms of Service | Smart Service</title>
        <meta name="description" content="Terms and conditions for using Smart Service website and services." />
      </Head>

      <main className="max-w-3xl mx-auto p-6">
        <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: July 15, 2025</p>

        <section className="mb-6">
          <p>
            Welcome to SMART SERVICE. These Terms of Service (“Terms”) govern your access to and use of our website and services.
            By using our platform, you agree to be bound by these Terms.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. Services Offered</h2>
          <p>
            SMART SERVICE provides manpower recruitment (skilled, semi-skilled, unskilled), government tender support,
            and related business services across Gujarat and India.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. User Responsibilities</h2>
          <ul className="list-disc ml-5 space-y-1">
            <li>Provide accurate and truthful information when submitting any request or form.</li>
            <li>Use the platform only for lawful business purposes.</li>
            <li>Do not engage in abusive, harassing, or fraudulent behavior.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. Payments and Invoicing</h2>
          <p>
            Payments, if any, for services will be outlined clearly before proceeding. Invoices are generated electronically
            and sent via email. Refunds are subject to our <Link href="/refund" className="text-blue-600 underline">Refund Policy</Link>.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Privacy and Data</h2>
          <p>
            Please refer to our <Link href="/privacy" className="text-blue-600 underline">Privacy Policy</Link> to understand how we collect,
            use, and protect your information.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">5. Intellectual Property</h2>
          <p>
            All content on this website, including text, graphics, logos, and branding, is owned by SMART SERVICE.
            Do not copy, distribute, or use without permission.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">6. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your access if we find violations of these terms or any illegal activity.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">7. Limitation of Liability</h2>
          <p>
            SMART SERVICE shall not be held liable for any direct or indirect damages resulting from the use of our services or site.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">8. Modifications</h2>
          <p>
            We may update these Terms occasionally. Continued use of our services after changes means you agree to the new Terms.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold mb-2">9. Contact Us</h2>
          <p>
            📧 Email: <a href="mailto:contact@smartservice.in" className="text-blue-600 underline">contact@smartservice.in</a><br />
            📞 Phone: +91-XXXXXXXXXX
          </p>
        </section>
      </main>
    </>
  );
};

export default TermsPage;
